import { Label } from "../../atoms/Label";
import { Typography } from "../../atoms/Typography";
import { SelectList, SelectListItem } from "../../atoms/Select";
import {
  CautionText,
  ItemWrapper,
  ResendWelcomeMailLayout,
  ResendWelcomeMailLayoutProps,
} from "./ResendWelcomeMailLayout";

/**
 * ウェルカムメール再送ページ (シークレットコードを再発行する初回契約向け)
 */
export type ResendSecretCodeWelcomeMailPageProps = Omit<
  ResendWelcomeMailLayoutProps,
  "children"
> & {
  passwordResetMemberId?: string;
  onSelectPasswordResetMember: (id?: string) => void;
};

/** メンバーを指定しない (パスワードをリセットしない) ことを表す選択肢 */
const none = {
  id: "none",
  name: "パスワードのリセットを行わない",
};

export function ResendSecretCodeWelcomeMailPage({
  passwordResetMemberId,
  onSelectPasswordResetMember,
  resendWelcomeMailTarget,
  ...layoutProps
}: ResendSecretCodeWelcomeMailPageProps) {
  const members = [none].concat(resendWelcomeMailTarget.members);
  const items = members.map((member) => (
    <SelectListItem value={member.id} key={member.id}>
      <Typography size={2}>{member.name}</Typography>
    </SelectListItem>
  ));
  const handleSelectPasswordResetMember = (value: string | number) => {
    if (typeof value !== "string") {
      return;
    }
    onSelectPasswordResetMember(value === "none" ? undefined : value);
  };

  return (
    <ResendWelcomeMailLayout
      resendWelcomeMailTarget={resendWelcomeMailTarget}
      {...layoutProps}
    >
      <ItemWrapper width="100%" $caution $bold>
        <CautionText $marginBottom="12px">
          ウェルカムメールを再送を行うと、製品管理責任者宛にウェルカムメールが再送されます。
          <br />
          またメンバーを指定した場合はパスワードをリセットして再送されます。
          <br />
          <br />
          パスワードをリセットされたメンバーは、ウェルカムメールに記載のシークレットコードを使用して再度パスワードの設定を行う必要があるため、
          <br />
          すでに利用されているPdtで再送を行う場合はご注意ください。
        </CautionText>
      </ItemWrapper>
      <ItemWrapper width="100%">
        <Label text={"パスワードをリセットするメンバー"} margin="0 0 7px 0" />
        <SelectList
          placeholder=""
          value={passwordResetMemberId || "none"}
          items={items}
          onValueChange={handleSelectPasswordResetMember}
        />
      </ItemWrapper>
    </ResendWelcomeMailLayout>
  );
}
